module.exports = __webpack_public_path__ + "static/bgHeroTrabaja-814fa1479979c4b203fee6659cdcd7ac.jpg";